import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4132186a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "darkblue" }
const _hoisted_2 = {
  class: "template",
  id: "experience"
}
const _hoisted_3 = ["data-aos"]
const _hoisted_4 = { class: "timeline-container" }
const _hoisted_5 = { class: "timeline" }
const _hoisted_6 = { class: "timeline-marker" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "marker-dot" }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "marker-line"
}
const _hoisted_9 = { class: "timeline-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "job-info" }
const _hoisted_12 = { class: "job-company" }
const _hoisted_13 = { class: "job-year" }
const _hoisted_14 = { class: "job-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 7.5L10 12.5L15 7.5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_16 = [
  _hoisted_15
]

import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { FadeDown } from '@/constants/app';
import { ref } from 'vue';

interface WorkExperience {
    company: string;
    year: string;
    title: string;
    description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkHistory',
  setup(__props) {

const { t } = useLanguageSwitcher();

const experiences: WorkExperience[] = [
    {
        company: 'Pfizer',
        year: '2017-2018',
        title: 'Software Engineering Intern',
        description: 'I was offered a 6 month internship and was one of 3 interns that were asked to stay for an additional 6 months. My days were spent moving a Microsoft Access database filled with data of raw materials to SQL Server for better performance and efficiency. With time to spare, I was able to build a GUI in Java to help view the data'
    },
    {
        company: 'Symbotic',
        year: '2018-2019',
        title: 'Software Engineer I',
        description: 'Here I did a few things. I debugged bot pickup and deliveries, package placements, routing and bot collision issues with the intent of learning the ins and outs of a complex codebase and an even more complex product.'
    },
    {
        company: 'TSD Solutions',
        year: '2019-2021',
        title: 'Mobile App Developer',
        description: 'Here I Lead the design and development of the iOS app "TSDDealer" targeted for car dealerships companies. Built in Xamarin/XAML and C# in MVVM architecture allowed us to release the app to both Android and iOS.'
    },
    {
        company: 'Started AskChris LLC',
        year: '2021-Present',
        title: 'Founder',
        description: 'I started AskChris LLC in 2021 with the goal of providing software development services to small businesses and individuals. I have since built a portfolio of clients and projects that I am proud of.'
    },
    {
        company: 'Fortune 500 Company',
        year: '2021-2025',
        title: 'Teradyne',
        description: 'My time there was rewarding in so many aspects. Originally hired for a C# project that was shelfed 3 months later, I began leading development cordination efforts on a sustaining project that would later net 1.2million in it\'s success. During this time I was exposed to sales and corporation relations. Shortly, after that, I began piecing together our aquistion partnership with executives and never looked back.'
    },
    {
        company: 'Robotics Company',
        year: '2025-Present',
        title: 'Software Engineer',
        description: ''
    }
];

const expandedItems = ref<Set<number>>(new Set());

const toggleExpanded = (index: number) => {
    if (expandedItems.value.has(index)) {
        expandedItems.value.delete(index);
    } else {
        expandedItems.value.add(index);
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        "data-aos": _unref(FadeDown),
        class: "title"
      }, "Work Experience", 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(experiences, (experience, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["timeline-item", { 'expanded': expandedItems.value.has(index) }])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                (index < experiences.length - 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: "job-header",
                  onClick: ($event: any) => (toggleExpanded(index))
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(experience.company), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(experience.year), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(experience.title), 1),
                  _createElementVNode("div", {
                    class: _normalizeClass(["expand-icon", { 'expanded': expandedItems.value.has(index) }])
                  }, _hoisted_16, 2)
                ], 8, _hoisted_10),
                _createElementVNode("div", {
                  class: _normalizeClass(["job-description", { 'expanded': expandedItems.value.has(index) }])
                }, [
                  _createElementVNode("p", null, _toDisplayString(experience.description), 1)
                ], 2)
              ])
            ], 2)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})